{
	"title": "Indexing photo metadata…",
	"description": "Culling will start automatically when indexing is complete.",
	"counter": "{{completed}} / {{total}} photos",
	"failed_one": "Metadata could not be read for {{count}} photo. Indexing will continue.",
	"failed_other": "Metadata could not be read for {{count}} photos. Indexing will continue."
}
